import { LocalizationService } from './LocalizationService';
/**
 * A Vue component which provides a localization service.
 * Expects a language string as a property of the component.
 */

var LocalizationProvider = {
  props: {
    language: String
  },
  data: function data() {
    return this.getChildContext();
  },
  watch: {
    language: function language(newLanguage) {
      this.$data.kendoLocalizationService.language = newLanguage;
    }
  },
  provide: function provide() {
    return {
      kendoLocalizationService: this.$data.kendoLocalizationService
    };
  },
  methods: {
    /**
     * Returns a localization service.
     * The method is suitable for overriding when you
     * implement custom localization behavior.
     */
    getLocalizationService: function getLocalizationService() {
      return new LocalizationService(this.$props.language);
    },

    /**
     * @hidden
     */
    getChildContext: function getChildContext() {
      return {
        kendoLocalizationService: this.getLocalizationService()
      };
    }
  },

  /**
   * @hidden
   */
  // @ts-ignore
  render: function render(h) {
    return h("div", [this.$slots.default]);
  }
};
export { LocalizationProvider };